// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"text-block-module--text-block--3_FBY"};